import i18n from "i18next";
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './localizations/en';
import ru from "./localizations/ru";
import uk from "./localizations/uk";

export const languages = [
    { key: "en", value: "ENG", ISO: "en-US" },
    { key: "ru", value: "РУС", ISO: "ru-RU" },
    { key: "uk", value: "УКР", ISO: "uk-UA" }
];

export function getIso(language) {
    return languages.find(x => x.key === language).ISO;
}

i18n.use(LanguageDetector).use(initReactI18next).init({
        resources: {
            en: en,
            ru: ru,
            uk: uk
        },
    fallbackLng: "ru",
    debug: true,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ","
            }
            ,

    react: {
        wait: true
    },

    detection: { caches: ['localStorage'], lookupLocalStorage: 'i18nextLng'}

});

export default i18n;